// extracted by mini-css-extract-plugin
module.exports = {"intro":"welcome-module--intro--15NY1","welcomeEmoji":"welcome-module--welcome-emoji--2dkvY"};